import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useHash } from '../../../hooks/useHash/useHash';

export const useAddCustomerReviewAllowed = () => {
  const {
    customerRatings: { ratingButtonEnabled, forceEnableRatingButtonParam },
  } = useConfig();
  const hash = useHash();

  if (ratingButtonEnabled) return true;

  if (
    ratingButtonEnabled === false &&
    forceEnableRatingButtonParam !== null &&
    hash.get(forceEnableRatingButtonParam) === 'true'
  ) {
    return true;
  }

  return false;
};
